<template>
    <v-dialog
        v-model="localDialog"
        width="35%"
        @update:modelValue="updateDialog"
        transition=""
        persistent
        :open-delay="0"
        :close-delay="0"
    >
        <v-card>
            <v-card-title class="text-h6">
                <span>{{ isEntryMode ? "Add Accounts Mapping" : "Update Accounts Mapping" }}</span>
            </v-card-title>

            <v-divider></v-divider>

            <v-card-text>
                <v-form @submit.prevent="submit" ref="AssetStatusTypesSetup">
                    <v-row>
                        <v-col  cols="12">
                            <v-autocomplete
                            variant="outlined"
                            density="compact"
                            bg-color="grey-lighten-4"
                            v-model="asset_category_id.value.value"
                            :items="getAssetCategoryList"
                            :item-title="(item) => item.name"
                            item-value="id"
                            autocomplete="off"
                            :loading="category_loading"
                            :error-messages="asset_category_id.errorMessage.value"
                            clearable                        
                            
                                :menu-props="{ contentClass: 'my-custom-dropdown' }"
>
                                <template #label>
                                Asset Category <span class="text-red-accent-4">*</span>
                                </template>
                            </v-autocomplete> 

                        </v-col>
                        
                    </v-row>
                    <v-row>
                    </v-row>

                    <v-divider></v-divider>

                    <v-card-actions>
                        <v-layout class="justify-end">
                            <v-btn
                            class="bg-red"
                            variant="flat"
                            type="reset"
                            @click="closeDialog"
                            >Close</v-btn>
                            <v-btn class="bg-brand w-15 ms-2" variant="flat" type="submit">
                                {{ isEntryMode ? "Save" : "Update" }}
                            </v-btn>
                        </v-layout>
                    </v-card-actions>
                </v-form>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
import { ref, watch } from "vue";
import { useStore } from "vuex";
import { useField, useForm } from "vee-validate";
import * as yup from "yup";
import { toast } from "vue3-toastify";

export default {
    name: "Asset Categories",
    props: {
        dialog: {
            type: Boolean,
            default: false,
        },
        data: {
            type: Object,
            default: () => ({
                asset_category_id: "",
                status: 1,
            }),
        },
    },
    data() {
        return {
            localDialog: this.dialog,
            errorMessages: "",
            loading: false,
            isEntryMode: true,
            category_loading: false,
        };
    },
    computed: {
        getAssetCategoryList() {
            let data = this.$store.getters.getAssetCategoryList;
            if (data.length > 0) {
                return data.filter((item) => item.status == 1);
            }
            return [];
        },
    },
    watch: {
        dialog(val) {
            this.localDialog = val;
        },
        localDialog(val) {
            this.$emit("update:dialog", val);
        },
        data: {
            handler(newData) {
                this.isEntryMode = !newData.id;
                this.resetForm({ errors: {}, touched: {} });
                this.account_head_id.setValue(newData.id || "", false);
                this.asset_category_id.setValue(newData.asset_category_id || null, false);
                this.status.setValue(newData.status, false);
            }
        },
    },
    created() {
        // if(this.$store.getters.getAssetCategoryList.length === 0){
            this.category_loading = true;
            this.$store.dispatch("getAssetCategoryList").then((response) => {
                this.category_loading=false;
            });
        // }
    },
    methods: {
        updateDialog(val) {
            this.$emit("update:dialog", val);
        },
        closeDialog() {
            this.$emit("update:dialog", false);
        },
    },
    setup(props, { emit }) {
        const { handleSubmit, resetForm } = useForm({
            validationSchema: yup.object({
                asset_category_id: yup.string("Asset Category Must be string").required().label("Name"),
            }),
        });
        const account_head_id = useField("account_head_id");
        const asset_category_id = useField("asset_category_id");
        const status = useField("status");
        const errorMessages = ref("");
        const loading = ref("");
        const store = useStore();

        const submit = handleSubmit((values) => {
            console.log(values)
        store
            .dispatch("saveUpdatAssetMapping", values)
            .then((response) => {
                resetForm();
                emit("update:dialog", false);
                toast.success(response.data.message);
                loading.value = true;
                store
                    .dispatch("getAssetMapplingsList")
                    .then((data) => {
                        loading.value = false;
                    })
                    .catch((error) => {
                        loading.value = false;
                        toast.error(error.response.data.message);
                    });
            })
            .catch((error) => {
                toast.error(error.response.data.message);
            });
        });
        return {
            submit,
            account_head_id,
            asset_category_id,
            status,
            errorMessages,
            resetForm,
            loading,
        };
    },
    mounted() {},
    
}

</script>
